let API_URL;
if (document.location.host === "madrasironingcompany.com" || document.location.host === "www.madrasironingcompany.com"){
    API_URL = `http://${document.location.host}:8000/graphql`
}
else{
    API_URL = "http://192.168.56.101:8000/graphql"
}

export default {
    API_URL : API_URL
}